import React, { Fragment } from 'react';
import { withStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';

const styles = theme => ({
  span: {
    fontFamily: 'IBM Plex Sans, medium',
    fontWeight: 500,
  },
  tooltipText: {
    color: '#0c0606de',
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.5
  }
});

class SSODomainName extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <Typography className={classes.tooltipText}>Add the domain name used for this institute's email addresses.<br />eg. chisholm.edu.au</Typography>
      </Fragment>
    )
  }

}

export default withStyles(SSODomainName, styles, { withTheme: true });
